import store from '@/store'
import { auth } from '@/auth/hyper-auth'

/**
 *
 * @returns Boolean - if user is logged
 */
const isUserLoggedIn = async () => {
    if (localStorage.getItem(auth.authConfig.storageTokenKeyName)) {
        if (!store.getters.authUserInfo.userIdx) {
            await store.dispatch('getAuthResource')
        }
        if (store.getters.authUserInfo.userIdx) {
            return Promise.resolve(true)
        }
    }
    return Promise.resolve(false)
}

const getUserInfo = () => store.getters.authUserInfo

const getNeedPrerequisite = () => store.getters.needPrerequisite

const getAuthPrerequisites = () => store.getters.authPrerequisites

export {
    isUserLoggedIn,
    getUserInfo,
    getNeedPrerequisite,
    getAuthPrerequisites
}
